function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-943.000000, -39.000000)",
  stroke: "#333333",
  strokeWidth: 1.4
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(838.000000, 25.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(106.000000, 14.272727)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 0.727273)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.8727273,11.84 C17.1818182,10.56 18,8.96 18,7.2 C18,3.2 13.9909091,0 9,0 C4.00909091,0 0,3.2 0,7.2 C0,11.2 4.00909091,14.4 9,14.4 C9.9,14.4 10.7181818,14.32 11.5363636,14.08 L16.3636364,16 L15.8727273,11.84 Z"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.72727273,
  y1: 5.6,
  x2: 12.2727273,
  y2: 5.6
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.72727273,
  y1: 8.8,
  x2: 9.81818182,
  y2: 8.8
}))))))));
var SvgIconComment = function SvgIconComment(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconComment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-comment.0fc913da.svg";
export { ForwardRef as ReactComponent };